import { FC, useEffect, useState } from 'react';

import { addIcon, lockIcon, prize } from '../../../assets';
import { useTranslation } from 'react-i18next';
import { GiftShop_State } from '../../../generated/mlmbox/types/gift_shop';

import { formatNumberString } from '../../../utils/helper';

import { getInfoForMarket } from '../../../shared/api/market';

import MarketCard from './MarketCard/MarketCard';
import { BonusPage } from '../types';

import styles from './Market.module.scss';
import Loader from '../../../shared/ui/Loader/Loader';
import BonusEarnDetails from '../../Bonus/Components/BonusEarnDetails/BonusEarnDetails';

import { useNavigate } from 'react-router';
import PageHeader from '../../../shared/ui/PageHeader/PageHeader';
import ShodawButton from '../../../shared/ui/ShadowButton/ShodawButton';

const Market: FC = () => {
    const [marketData, setMarketData] = useState<GiftShop_State>();
    const { t } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
        getInfoForMarket().then((res) => res && setMarketData(res));
    }, []);

    return (
        <div className={styles.market}>
            {marketData && (
                <div className="start">
                    <PageHeader
                        title={t('market')}
                        closeBtn={() => navigate('/bonus')}
                    />

                    <>
                        <div className={styles.info}>
                            <BonusEarnDetails
                                icon={prize}
                                title={t('avaible')}
                                value={formatNumberString(marketData?.pointsBalanceAvailable ?? '0')}
                            />
                            <BonusEarnDetails
                                icon={lockIcon}
                                title={t('hold')}
                                value={formatNumberString(marketData?.pointsBalanceFrozen ?? '0')}
                            />
                        </div>

                        <div className={styles.cards}>
                            {marketData.cards.map((card) => (
                                <MarketCard
                                    {...card}
                                    needReviewCardIds={marketData.needReviewCardIds}
                                    balanceAvaible={Number(marketData.pointsBalanceAvailable)}
                                    key={card.id}
                                />
                            ))}
                        </div>

                        {/* <div className={styles.btn}>
                            <div className={styles.bg}></div>
                            <button onClick={() => setPageCard && setPageCard({ value: BonusPage.NEW_CARD })}>
                                <img
                                    src={addIcon}
                                    alt=""
                                />
                                {t('add_btn')}
                            </button>
                        </div> */}

                        <ShodawButton
                            bg="linear-gradient(180deg, rgba(24, 26, 34, 0) 0%, #181A22 35.45%)"
                            title={t('add_btn')}
                            icon={addIcon}
                            onClick={() => navigate('/create')}
                        />
                    </>
                </div>
            )}
            {/* {!marketData && <Loader fullScreen />} */}
        </div>
    );
};

export default Market;
